import { render } from "./MultiEnable.vue?vue&type=template&id=b8f48c7a&scoped=true"
import script from "./MultiEnable.vue?vue&type=script&lang=js"
export * from "./MultiEnable.vue?vue&type=script&lang=js"

import "./MultiEnable.vue?vue&type=style&index=0&id=b8f48c7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8f48c7a"]])

export default __exports__